module.exports = __webpack_public_path__ + "static/media/silver-ticket-transparent.1b07cd2c.png";